import React, { Component } from 'react';
import { connect } from "react-redux";

import Select from 'react-select';
import { debounce } from "lodash";
import axios from "axios";
import moment from "moment";

import EditBookingPullout from "../Common/EditBookingPullout";
import NewBookingPullout from "../Common/NewBookingPullout";
import VehicleCell from "../Pages/Stakeholder/Vehicle/VehicleCell";
import ProfileCell from "../Pages/Stakeholder/User/ProfileCell";

import { setVehicleDb, setBookingsDb, setReturnReleaseBookings } from '../../Actions/dataActions';
import { openPullout, closePullout, setList, configureBookingDictionary, endPulloutEdit } from "../../Actions/stakeholderActions";

import { constants } from '../../Helpers/Constants';
import { receiveTime } from '../../Helpers/ReceiveTimeInArray';
import { ActionCheck, ActionClose } from '../Common/Buttons/Icons';
import { Trans } from 'react-i18next';
import ViewBookingPullout from '../Common/ViewBookingPullout';
class SHBookingPullout extends Component {
    constructor(props) {
        super(props);

        this.cancelBooking = debounce(this.cancelBooking.bind(this), 500);
        this.editBooking = this.editBooking.bind(this);
        this.viewBooking = this.viewBooking.bind(this);
        this.closePullout = this.closePullout.bind(this);
        this.approveBooking = debounce(this.approveBooking.bind(this), 500);
        this.rejectBooking = debounce(this.rejectBooking.bind(this), 500);
        this.generateStatusBadge = this.generateStatusBadge.bind(this);

        this.state = {
            edit: false,
            new: false,
            booking: this.props.stakeholder.current_booking
        };
    }

    componentDidMount() {
        if (this.state.booking.edit) {
            this.setState({
                edit: true
            });
        } else if (this.state.booking.new) {
            this.setState({
                new: true
            });
        } else {
            this.setState({edit: false, new: false})
        }
    }

    componentDidUpdate (prevProps) {
        if (prevProps.stakeholder.current_booking !== this.props.stakeholder.current_booking) {
            this.setState({
                booking: this.props.stakeholder.current_booking
            })
    
            if (this.props.stakeholder.current_booking.edit) {
                this.setState({
                    edit: true
                });
            } else if (this.props.stakeholder.current_booking.new) {
                this.setState({
                    new: true
                });
            } else {
                this.setState({edit: false, new: false})
            }
        }
    }

    cancelBooking(callCancelBookingGraphQL) {
        var self = this;

        if (window.confirm("Are you sure you would like to cancel this booking?")) {
            axios.post('/ajax/booking/' + self.props.stakeholder.current_booking.BOOK_ID + '/delete')
            .then(function(response) {
                var data = { search_term: $("#searchbar").val(),
                            vmh: $("input[name='vmh[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            sh: $("input[name='sh[]']:checked").map(function () { return this.value; }).get().join('#'),
                            start_date: self.props.stakeholder.current_date.clone().subtract(3, 'weeks'),
                            end_date: self.props.stakeholder.current_date.clone().add(3, 'weeks')
                        }

                if (self.props.stakeholder.booking_next_page !== null && self.props.stakeholder.booking_next_page > 0) {
                    data['grab_all_pages'] = self.props.stakeholder.booking_next_page;
                }

                // [not in use due to queue data sync implementation]
                // callCancelBookingGraphQL();
                showStatusMsg('Booking cancelled successfully.', 'success');
                window.location.reload();
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";
    
                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });
    
                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    editBooking() {
        this.setState({
            edit: !this.state.edit
        })
    }

    closePullout() {
        this.setState({
            edit: false,
            new: false
        })

        if (this.state.booking.calendarRef) {
            this.state.booking.calendarRef.unselect();
        }
        this.props.dispatch(closePullout());
    }

    viewBooking(booking) {
        this.setState({
            edit: false,
            new: false,
            booking: booking
        });
        this.state.booking
    }

    approveBooking(updateBookingGraphQL) {

        axios.post('/ajax/booking/' + this.state.booking.BOOK_ID + '/approve')
            .then((response) => {
                // [not in use due to queue data sync implementation]
                // updateBookingGraphQL({ status: 'booked' })

                // axios.get('/ajax/booking/' + this.props.stakeholder.current_booking.BOOK_ID)
                //     .then((response2) => {
                //         this.props.dispatch(openPullout(response2.data.booking))
                //         this.props.dispatch(setBookingsDb([response2.data.booking], self.props.data.bookings_db));
                //     })

                showStatusMsg(response?.data.message, 'success');
                window.location.reload();
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    rejectBooking() {
        this.props.history.push(`${this.props.match.url}/rejectbooking/${this.state.booking.BOOK_ID}/${this.state.booking.extendedProps.booking.id}`);
        this.props.dispatch(closePullout())
    }

    generateStatusBadge(booking) {
        if(booking.Book_Status >= constants.booking_status.pending_oem && booking.Book_Status <= constants.booking_status.pending_both) {
            return(
                <div className = "status-badge bkg-yellow float-left mr-16 mt-8"><Trans>Pending</Trans></div>
            );
        } else if(booking.Book_Status === constants.booking_status.denied) {
            return(
                <div className = "status-badge bkg-red float-left mr-16 mt-8"><Trans>Rejected</Trans></div>
            );
        } else if(booking.Book_Status === constants.booking_status.cancelled) {
            return(
                <div className = "status-badge bkg-black-light float-left mr-16 mt-8"><Trans>Cancelled</Trans></div>
            );
        } else {
            if(((moment()).isAfter(moment(booking.Start_Date)) && booking.Released_On === null) || ((moment()).isAfter(moment(booking.End_Date)) && booking.Released_On !== null && booking.Returned_On === null)) {
                if(booking.Released_On === null && (moment().add(1, 'hour')).isAfter(moment(booking.Start_Date + " " + booking.Release_Time))) {
                    return(
                        <div className = "status-badge bkg-yellow float-left mr-16 mt-8"><Trans>Late Release</Trans></div>
                    );
                } else if(booking.Returned_On == null && (moment().add(1, 'hour')).isAfter(moment(booking.End_Date + " " + booking.Return_Time))) {
                    return(
                        <div className = "status-badge bkg-yellow float-left mr-16 mt-8"><Trans>Late Check in</Trans></div>
                    );
                } else {
                    return(
                        <div className = "status-badge bkg-primary float-left mr-16 mt-8"><Trans>Current</Trans></div>
                    );
                }
            } else if(booking.Released_On !== null && booking.Returned_On !== null) {
                return(
                    <div className = "status-badge bkg-green float-left mr-16 mt-8"><Trans>Completed</Trans></div>
                );
            } else {
                return(
                    <div className = "status-badge bkg-primary float-left mr-16 mt-8"><Trans>Upcoming</Trans></div>
                );
            }
        }
    }

    render() {
        if (this.props.stakeholder.pullout) {
            if (this.state.edit) {
                return (
                    <EditBookingPullout 
                        booking={this.state.booking} 
                        highlightEvent={this.state.booking.highlightEvent}
                        toggleEditBooking={this.editBooking} 
                        closePullout={this.closePullout} 
                        key={this.state.booking.BOOK_ID} 
                        endEdit={()=> {
                            let b = this.state.booking;
                            b['edit'] = false;
                            this.setState({edit: false, booking: b});
                            endPulloutEdit();
                        }}
                    />
                )
            } else if (this.state.new) {
                return (
                    <NewBookingPullout 
                        booking={this.state.booking}
                        closePullout={this.closePullout}  
                        history={this.props.history} 
                        match={this.props.match} 
                        viewBooking={this.viewBooking}
                    />
                )
            } else if (this.state.booking.BOOK_ID) {
                return(
                    <ViewBookingPullout 
                        booking={this.state.booking} 
                        toggleEditBooking={this.editBooking} 
                        closePullout={this.closePullout} 
                        key={this.state.booking.BOOK_ID} 
                        history={this.props.history} 
                        match={this.props.match} 
                        highlightEvent={this.state.booking.highlightEvent}
                        cancelBooking={this.cancelBooking}
                        approveBooking={this.approveBooking}
                        rejectBooking={this.rejectBooking}
                    />
                )
            } else {
                return null;
            }
        } else {
            return (
                null
            )
        }

    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    settings: store.settings,
    stakeholder: store.stakeholder
});

export default connect(mapStateToProps)(SHBookingPullout);